const let_6 = [
    "baking",
    "batter",
    "bisque",
    "buffet",
    "canape",
    "caviar",
    "cordon",
    "entree",
    "frappe",
    "giblet",
    "gluten",
    "incise",
    "junket",
    "kosher",
    "mousse",
    "napper",
    "ragout",
    "reduce",
    "skewer",
    "blanch",
    "braise",
    "coddle",
    "dollop",
    "dredge",
    "entree",
    "fillet",
    "grease",
    "leaven",
    "render",
    "sachet",
    "simmer",
    "ticket",
    "carrot",
    "celery",
    "garlic",
    "potato",
    "turnip",
    "legume",
    "banana",
    "cherry",
    "orange",
    "papaya",
    "tomato",
    "cereal",
    "edible",
    "legume",
    "mutton",
    "rabbit",
    "turkey",
    "breast",
    "mutton",
    "shrimp",
    "canned",
    "caviar",
    "fillet",
    "oyster",
    "button",
    "butter",
    "cheese",
    "grater",
    "kettle",
    "napkin",
    "formal",
    "napkin",
    "shaker",
    "course",
    "waiter",
    "cancer",
    "market",
    "profit",
    "stroke",
    "haggis",
    "bisque",
    "bistro",
    "mousse",
    "tamale",
    "squash",
    "garlic",
    "muffin",
    "dinner",
    "bloody",
    "brandy",
    "nectar",
    "excape",
    "waiter",
    "mutton",
    "tamale",
    "sesame",
    "imbibe",
    "shandy",
    "ribbon",
    "liquor",
    "reheat",
    "palace",
    "purple",
    "ethnic",
    "loving",
    "course",
    "eatery",
    "guzzle",
    "active",
    "butter",
    "scotch",
    "picnic",
    "dining",
    "peanut",
    "thirst",
    "velvet",
    "flavor",
    "spiced",
    "masher",
   "staple",
    "simply",
    "grouse",
    "supply",
    "peeler",
    "tomato",
    "grille",
    "rustic",
    "trifle",
    "smoked",
    "author",
    "fiesta",
    "brunch",
    "evenly",
    "tavern",
    "market",
    "waffle",
    "wooden",
    "frothy",
    "raiser",
    "potato",
    "lounge",
    "salmon",
    "parrot",
    "trivet",
    "stripe",
    "silent",
    "jungle",
    "sorrel",
    "hawker",
    "parlor",
    "powder",
    "oxtail",
    "manger",
    "banana",
    "pastry",
    "frozen",
    "pewter",
    "shoppe",
    "recipe",
    "baking",
    "cooker",
    "cheese",
    "buffet",
    "boiled",
    "remove",
    "flying",
    "lavish",
    "family",
    "hookah",
    "silver",
    "greasy",
    "simmer",
    "liquid",
    "mother",
    "sinful",
    "turkey",
    "turner",
    "golden",
    "wasabi",
    "cashew",
    "chunky",
    "bubble",
    "hearty",
    "fondue",
    "porter",
    "brewer",
    "noodle",
    "crispy",
    "carrot",
    "potato",
    "monkey",
    "spiked",
    "cowboy",
    "nestle",
    "victor",
    "repast",
    "bakery",
    "starch",
    "corner",
    "shiner",
    "forger",
    "flower",
    "subway",
    "coffee",
    "graham",
    "candle",
    "batter",
    "wilder",
    "shrimp",
    "omelet",
    "patina",
    "icebox",
    "monger",
    "sloppy",
    "wiener",
    "tipple",
    "pepper",
    "palate",
    "sundae",
    "sprite",
    "broken",
    "nearby",
    "eggnog",
    "sugary",
    "fruity",
    "deluxe",
    "center",
    "hungry",
    "tinned",
    "paring",
    "cordon",
    "citrus",
    "orchid",
    "canned",
    "gently",
    "relish",
    "braise",
    "supper",
    "mellow",
    "toilet",
    "butane",
    "martin",
    "nicely",
    "master",
    "kosher",
    "lentil",
    "heaven",
    "soiree",
    "dickey",
    "savory",
    "exotic",
    "nickel",
    "papaya",
    "galley",
    "hominy",
    "tender",
    "potpie",
    "finger",
    "sherry",
    "casual",
    "bistro",
    "corral",
    "island",
    "bamboo",
    "triple",
    "tarpon",
    "expert",
    "fresco",
    "bottle",
    "poodle",
    "sodium",
    "entree",
    "fillet",
    "grocer",
    "oyster",
    "stewed",
    "frosty",
    "tartar",
    "crusty",
    "breeze",
    "fusion",
    "creole",
    "cognac",
    "sliced",
    "creamy",
    "plumed",
    "garden",
    "petite",
    "nestle",
    'family',
    "ensure",
    'napkin',
    'cheesy',
    'simple',
    'spiral',
    'triple',
    "creamy",
    "trifle",
    'hominy',
    "ginger",
    'stripe',
    "jujube",
    "bronze",
    "baking",
    "oyster",
    "peeled",
];

export default let_6;
